import React from "react";
import { motion } from "framer-motion";
import { CheckCircleIcon } from "@heroicons/react/24/solid";
import PopularPackageLinks from "./PopularPackageLinks";

const container = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      when: "beforeChildren",
      staggerChildren: 0.25,
    },
  },
};

const item = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0 },
};

const confettiVariants = {
  animate: {
    y: ["-20vh", "100vh"],
    x: ["-10vw", "10vw"],
    opacity: [1, 0],
    rotate: [0, 360],
    transition: {
      repeat: Infinity,
      duration: 6,
      ease: "easeInOut",
    },
  },
};

const confettiColors = [
  "#F87171", "#FBBF24", "#34D399", "#60A5FA", "#A78BFA",
  "#F472B6", "#FB923C", "#10B981",
];

const ThanksPage = () => {
  return (
    <motion.section
      className="min-h-screen pt-[130px] flex flex-col justify-between bg-gradient-to-br from-green-50 to-white px-4 relative overflow-hidden"
      variants={container}
      initial="hidden"
      animate="visible"
    >
      {/* Confetti */}
      {Array.from({ length: 50 }).map((_, i) => {
        const size = Math.random() * 8 + 4;
        const shape = Math.random() > 0.5 ? "rounded-full" : "rounded-sm";
        const color = confettiColors[Math.floor(Math.random() * confettiColors.length)];
        return (
          <motion.div
            key={i}
            className={`absolute ${shape}`}
            style={{
              width: size,
              height: size,
              top: `${Math.random() * 100}vh`,
              left: `${Math.random() * 100}vw`,
              backgroundColor: color,
              zIndex: 0,
            }}
            variants={confettiVariants}
            animate="animate"
          />
        );
      })}

      {/* Centered Card */}
      <div className="flex-grow flex items-center justify-center z-10">
        <motion.div
          className="bg-white rounded-2xl shadow-2xl max-w-2xl w-full text-center p-10 border border-green-100"
          variants={item}
        >
          <motion.div variants={item}>
            <CheckCircleIcon className="mx-auto text-[#007bff] w-24 h-24 mb-4 animate-bounce" />
          </motion.div>

          <motion.h1
            className="text-4xl font-bold text-[#007bff] mb-4"
            variants={item}
          >
            Thank You!
          </motion.h1>

          <motion.p
            className="text-gray-600 mb-6 leading-relaxed text-lg"
            variants={item}
          >
            We appreciate your interest. Our team will connect with you shortly
            to plan your memorable journey.
          </motion.p>
        </motion.div>
      </div>

      {/* Popular Links */}
      <div className="z-10">
        <PopularPackageLinks />
      </div>
    </motion.section>
  );
};

export default ThanksPage;
